import { useWindowSize } from 'react-easyrocket';

export const useGetGameNameFontSize = (gameName: string) => {
  const { is768 } = useWindowSize();

  const defaultSize = 12;
  const maxWordLength = is768 ? 11 : 10.5;

  if (!gameName) return defaultSize;

  const gameNameFirstWordLength = gameName?.split(' ')[0].length;

  const fontSizeCoefficient =
    gameNameFirstWordLength > maxWordLength ? maxWordLength / gameNameFirstWordLength : 1;

  return defaultSize * fontSizeCoefficient;
};
